<template>
  <div class="main-kv-container">
    <navigator-top v-if="navLists && navLists.length > 0" :nav-lists="navLists" />
    <navigator-side v-if="navLists && navLists.length > 0" :nav-lists="navLists" />
    <div class="main-kv" />
    <div class="video-container">
      <div class="video-box-container">
        <div ref="player" id="videobox" />
        <div v-if="isPaused" class="player-mask" @click="onPlay" v-rseat="'click_carnival_video'">
          <i class="icon-play" />
        </div>
      </div>
    </div>
    <div class="swiper-kv-bg-container">
      <div class="swiper-kv-container">
        <poster-swiper :pic-list="picList" />
      </div>
    </div>
    <div class="notice-bg-container">
      <div class="notice-container">
        <notice-bar :text="notice" :time="20" />
      </div>
    </div>
  </div>
</template>
<script>
import NavigatorTop from '@/components/carnival2020/navigator-top.vue'
import NavigatorSide from '@/components/carnival2020/side-navigator.vue'
import PosterSwiper from '@/components/carnival2020/poster-swiper.vue'
import NoticeBar from '@/components/carnival2020/notice-bar.vue'

export default {
  components: {
    NavigatorTop,
    NavigatorSide,
    PosterSwiper,
    NoticeBar,
  },
  props: {
    navLists: {
      type: Array,
      default: () => [],
    },
    video: {
      type: Object,
      default: () => {},
    },
    picList: {
      type: Array,
      default: () => [],
    },
    notice: {
      type: String,
      default: '暂无公告',
    },
  },
  data() {
    return {
      isPaused: true,
      player: null,
      click_carnival_video: 'click_carnival_video',
    }
  },
  methods: {
    initVideo() {
      if (window.QiyiPlayerLoader) {
        window.QiyiPlayerLoader.ready(manager => {
          this.player = manager.createPlayer({
            parentId: 'videobox',
            tvid: this.video ? this.video.id : 0,
            vid: 'd6d511787948b58f71f0ece0629a7226',
            autoplay: false,
            imageUrl: this.video ? this.video.img : '',
            imageLoader: this.video ? this.video.img : '',
          })
          this.player.on('playerStateChange', ({ data }) => {
            if (
              data.state !== 'adstartplay' &&
              data.state !== 'adplaying' &&
              data.state !== 'startplay' &&
              data.state !== 'playing'
            ) {
              this.isPaused = true
            } else {
              this.isPaused = false
            }
          })
        })
      } else {
        this.$message.warning('播放器加载失败，请刷新页面重试')
      }
    },
    onPlay() {
      this.player.play()
    },
  },
  mounted() {
    this.initVideo()
  },
}
</script>
<style lang="less">
.main-kv-container {
  .main-kv {
    background: transparent url('~@/assets/carnival2020/main-kv/main-kv.jpg') top center no-repeat;
    background-size: 1920px auto;
    overflow: auto;
    width: 100%;
    height: 647px;
    margin-top: 1px;
  }
  .video-container {
    background: transparent url('~@/assets/carnival2020/main-kv/video-bg.jpg') center center no-repeat;
    background-size: 1920px auto;
    width: 100%;
    height: 679px;
    position: relative;
    overflow: hidden;
    .video-box-container {
      width: 945px;
      height: 527px;
      position: absolute;
      top: 32px;
      left: 50%;
      transform: translateX(-48.9%);
      #videobox {
        width: 100%;
        height: 100%;
      }
      .player-mask {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.3);
      }
      .icon-play {
        display: block;
        background: transparent url('~@/assets/carnival2020/main-kv/button-play.png') center center no-repeat;
        background-size: contain;
        width: 109px;
        height: 109px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
      }
    }
  }
  .swiper-kv-bg-container {
    position: relative;
    overflow: hidden;
    background: transparent url('~@/assets/carnival2020/main-kv/swiper-bg.jpg') top center no-repeat;
    background-size: 1920px auto;
    width: 100%;
    height: 302px;
    margin-top: -1px;
    .swiper-kv-container {
      width: 1072px;
      height: 282px;
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      padding: 0;
    }
  }
  .notice-bg-container {
    position: relative;
    overflow: hidden;
    background: transparent url('~@/assets/carnival2020/main-kv/notice-bg.jpg') top center no-repeat;
    background-size: 1920px auto;
    width: 100%;
    height: 138px;
    .notice-container {
      width: 1100px;
      height: 87px;
      position: absolute;
      left: 50%;
      top: 27px;
      transform: translateX(-50%);
      padding: 35px 39px 32px 183px;
    }
  }
}
</style>
